module.exports = __webpack_public_path__ + "img/icon_profile_inactive_pc.a913a2b5.svg";